var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('c-list',{attrs:{"data":_vm.list.items,"columns":_vm.cList.columns,"total":_vm.list.total,"page-current":_vm.listPageCurrent,"search-where":_vm.listSearchWhere},on:{"selection-change":_vm.handleListSelectionChange}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }